import React from 'react';
import {
  buildRuntimeErrorPayload,
  normalizeError,
  reportRuntimeError,
} from '../lib/runtimeErrorMonitoring';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportRuntimeError(
      buildRuntimeErrorPayload('react.error_boundary', {
        error: normalizeError(error),
        componentStack: info?.componentStack ?? '',
      })
    );
  }

  handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen site-bg-canvas px-6 py-16 text-center text-gray-800">
          <p className="text-sm font-semibold uppercase tracking-widest text-gray-500">
            Erro inesperado
          </p>
          <h1 className="mt-4 text-3xl font-bold text-gray-900">Algo deu errado em runtime</h1>
          <p className="mx-auto mt-4 max-w-xl text-base text-gray-600">
            O erro foi registrado para analise. Recarregue a pagina para tentar novamente.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-8 rounded-md bg-gray-800 px-5 py-3 text-sm font-medium text-white transition hover:bg-gray-700"
          >
            Recarregar pagina
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
